import { useStore } from '@/store';
import style from './index.module.scss';
import cls from 'classnames';
import useSideBar from '@/hooks/useSideBar';
import { useMemo, useState } from 'react';
import { ClientHostType, DEVICE_TYPE, ROUTER_MAP } from '@/types';
import { useRouter } from '@/hooks/useRouter';
import { showMy } from '../Drawer';
import { Icons } from '@/packages';
import { useLocation } from 'ice';
import { getIntl } from '@/locales';
import IconAAcxlogo from '@/packages/iconfont/IconAAcxlogo';
import bonaLogo from '@/assets/img/bonaLogo.png';
import IconLogo from '@/packages/iconfont/IconLogo';
export function SideBar() {
  const intl = getIntl();
  const { device, channel } = useStore();
  const location = useLocation();
  const { showSideBar, setShowSideBar } = useSideBar();
  const defaultList = [
    {
      name: intl.formatMessage({ id: 'iWeb.components.Menu.HomePage', defaultMessage: '首页' }),
      link: ROUTER_MAP.HOME,
      svg: <Icons.IconShouyeXuanzhong />,
      active: ROUTER_MAP.HOME,
    },
    {
      name: intl.formatMessage({ id: 'iWeb.components.SideBar.Film', defaultMessage: '影片' }),
      link: ROUTER_MAP.FILM,
      svg: <Icons.IconDianyingXuanzhong />,
      active: ROUTER_MAP.FILM,
    },
    {
      name: intl.formatMessage({ id: 'iWeb.components.SideBar.ActivityMembershipCard', defaultMessage: '活動&會員卡' }),
      link: ROUTER_MAP.ACTIVITY_AND_VIP,
      svg: <Icons.IconHuodongWeixuanzhong />,
      active: ROUTER_MAP.ACTIVITY_AND_VIP,
    },
    {
      name: intl.formatMessage({ id: 'iWeb.pages.user.Mine', defaultMessage: '我的' }),
      fn: () => {
        showMy({});
      },
      svg: <Icons.IconWodeWeixuanzhong />,
      active: ROUTER_MAP.USER_INDEX,
    },
    // {
    //   name: '影院选择',
    //   fn: () => {
    //     showSeclectCinema({});
    //   },
    //   svg: <Icons.IconDianyingXuanzhong />,
    // },
    // {
    //   name: intl.formatMessage({ id: 'iWeb.components.SideBar.Login', defaultMessage: '登陆' }),
    //   fn: () => {
    //     showLoginDrawer({});
    //   },
    //   svg: <Icons.IconDenglu />,
    // },
  ];

  const [list] = useState(defaultList);
  const { jump } = useRouter();
  const handleClick = (item) => {
    if (item.link) {
      jump(item.link);
      if (device !== DEVICE_TYPE.PC) {
        setShowSideBar(false);
      }
    }
    if (item.fn) {
      item.fn?.();
      if (device !== DEVICE_TYPE.PC) {
        setShowSideBar(false);
      }
    }
  };
  const logoMap = useMemo(() => {
    return {
      [ClientHostType.acx]: <IconAAcxlogo className={style.logoitem} />,
      [ClientHostType.icirena]: (
        <div className={style.logoBg}>
          <img src={bonaLogo} />
        </div>
      ),
      [ClientHostType.galaxy]: <IconLogo className={style.logoitem} />,
    }[channel];
  }, [channel]);
  return (
    <>
      <div
        className={cls(style.sideBar, {
          [style.hide]: !showSideBar,
          [style.noPc]: !(device == DEVICE_TYPE.PC),
        })}
      >
        <div className={style.logo}>{logoMap}</div>
        <div className={style.container}>
          {list.map((item, index) => {
            return (
              <div
                className={cls(style.item, {
                  [style.active]: item.active === (location.pathname as unknown as ROUTER_MAP),
                })}
                key={index}
                onClick={() => {
                  handleClick(item);
                }}
              >
                <div className={style.icon}>{item?.svg}</div>
                <div className={style.name}>{item.name}</div>
              </div>
            );
          })}
        </div>
      </div>
      {device !== DEVICE_TYPE.PC && showSideBar && (
        <div
          className={style.mask}
          onClick={() => {
            setShowSideBar();
          }}
        />
      )}
    </>
  );
}
